import 'dayjs/locale/fr'

import dayjs from 'dayjs'
import customParseFormatPlugin from 'dayjs/plugin/customParseFormat'
import durationPlugin from 'dayjs/plugin/duration'
import isoWeekPlugin from 'dayjs/plugin/isoWeek'
import isSameOrBeforePlugin from 'dayjs/plugin/isSameOrBefore'
import localeDataPlugin from 'dayjs/plugin/localeData'
import localizedFormatPlugin from 'dayjs/plugin/localizedFormat'
import weekdayPlugin from 'dayjs/plugin/weekday'

dayjs.locale('fr')
dayjs.extend(durationPlugin)
dayjs.extend(weekdayPlugin)
dayjs.extend(localeDataPlugin)
dayjs.extend(localizedFormatPlugin)
dayjs.extend(customParseFormatPlugin)
dayjs.extend(isoWeekPlugin)
dayjs.extend(isSameOrBeforePlugin)

export default dayjs
